import React from "react"
import { Link } from "gatsby"
import { Card, CardText, CardSubtitle, CardBody, Badge } from "reactstrap"
import Img from "gatsby-image"
import site from "../../utilty/getURL"
import slugify from "../../utilty/utlityFunctions"

export default function Post({ post }) {
  return (
    <Card>
      <Link to={`${site.siteMetadata.siteUrl}/${post.slug}`}>
        <Img
          className="card-image-top"
          fluid={post.heroImage.fluid}
          alt={post.title}
        />
      </Link>
      <CardBody>
        <h1 className="heading pb-2 border-bottom border-dark ">
          <Link
            to={`${site.siteMetadata.siteUrl}/${post.slug}`}
            className="text-dark"
          >
            {post.title}
          </Link>
        </h1>
        {/* <h5 className="pb-2 border-bottom border-dark ">{post.title}</h5> */}
        <CardSubtitle>
          <span className="text-info ">{post.publishDate}</span> | by{" "}
          <Link to={`/hire-me`}>
            <span className="text-info">{post.author.name}</span>
          </Link>
        </CardSubtitle>
        <div
          className="text-justify"
          dangerouslySetInnerHTML={{
            __html: post.description.childMarkdownRemark.html,
          }}
        />
        <CardText>{post.body}</CardText>
        <ul className="post-tags row center justify-content-center pl-3">
          <p className="mr-2">Category : </p>
          {post.category.map((category, i) => (
            <li key={i}>
              <Link to={`/${slugify(category.title)}`}>
                <Badge color="primary" className="text-uppercase pr-1">
                  {category.title}
                </Badge>
              </Link>
            </li>
          ))}
        </ul>
        <Link
          to={`${site.siteMetadata.siteUrl}/${post.slug}`}
          className="btn btn-outline-primary float-right"
        >
          Read more
        </Link>
      </CardBody>
    </Card>
  )
}

//  category.description
